export default "__VITE_ASSET__i2NH0T6f__"